module.exports = __webpack_public_path__ + "static/media/login-background-1.09418474.svg";